import { render, staticRenderFns } from "./ClaimLimitAdjustmentGrid.vue?vue&type=template&id=4c417c5a"
import script from "./ClaimLimitAdjustmentGrid.vue?vue&type=script&lang=js"
export * from "./ClaimLimitAdjustmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports